import type { Key } from "path-to-regexp";
import { pathToRegexp } from "path-to-regexp";

/**
 * Just a wrapper around path-to-regexp library to add the
 * input on the output.
 */

export type RouteRegExp = RegExp & {
  originalPath?: string;
  keys?: Key[];
};
export default function pathRegExp(str: string): RouteRegExp {
  // store key descriptions
  const keys: Key[] = [];
  // @ts-ignore
  const result = pathToRegexp(str, keys) as RouteRegExp;
  result.originalPath = str;
  result.keys = keys;
  return result;
}

export const stringifyPath = (path: RouteRegExp | string): string =>
  typeof path === "string"
    ? path
    : (path?.originalPath ?? path?.toString?.() ?? "");
